import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output
} from "@angular/core";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

interface PlanningDefaultDraftDialogModel {
  defaultDraftId?: string;
  defaultDraftName?: string;
}

require('./planning-default-draft-dialog.scss');
@Component({
  standalone: false,
  selector: 'app-planning-default-draft-dialog',
  templateUrl: './planning-default-draft-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDefaultDraftDialogComponent implements OnInit {

  @Output() onClose = new EventEmitter<{ isUpdate: boolean, defaultDraftName: string }>();

  public formType: string;
  public defaultDraftId: string;
  public defaultDraftName: string;
  draftTemplateForm: FormGroup;

  constructor(@Inject(PANEL_DATA) public data: PlanningDefaultDraftDialogModel, @Inject(FormBuilder) private fb: FormBuilder) {
  }

  ngOnInit() {
    this.defaultDraftId = this.data.defaultDraftId;

    if (!!this.defaultDraftId) {
      this.formType = 'update';
    }

    this.draftTemplateForm = this.fb.group({
      name: [this.data.defaultDraftName || '', Validators.required],
    });
  }

  onSubmit() {
    if (this.draftTemplateForm.invalid) {
      this.draftTemplateForm.markAllAsTouched();
      return;
    }

    const payload = {
      defaultDraftName: this.draftTemplateForm.get('name')?.value,
      isUpdate: this.formType === 'update'
    };

    this.onClose.emit(payload);
  }

}
